<template>
    <div class="row">
        <div class="column left">
            <vertical-menu></vertical-menu>
        </div>
        <div class="column right">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import verticalMenu from './verticalMenu';
export default {
    name: 'categoryContent',
    components: {
        verticalMenu,
    },
};
</script>

<style scoped></style>
